<template>
  <section id="skills" class="skills">
    <h2>{{ $t("skills.title") }}</h2>
    <div class="skills-grid">
      <!-- Frontend -->
      <div class="skill-category">
        <h3>{{ $t("skills.frontend") }}</h3>
        <div class="skill-list">
          <div class="skill">
            <font-awesome-icon :icon="['fab', 'angular']" class="skill-icon" />
            <span>Angular</span>
          </div>
          <div class="skill">
            <font-awesome-icon :icon="['fab', 'js']" class="skill-icon" />
            <span>JavaScript</span>
          </div>
          <div class="skill">
            <font-awesome-icon :icon="['fab', 'html5']" class="skill-icon" />
            <span>HTML</span>
          </div>
          <div class="skill">
            <SassIcon :isDarkMode="isDarkMode" />
            <span>SCSS</span>
          </div>
          <div class="skill">
            <font-awesome-icon
              :icon="['fab', 'bootstrap']"
              class="skill-icon"
            />
            <span>Bootstrap</span>
          </div>
          <div class="skill skill-icon-container">
            <TailwindIcon :isDarkMode="isDarkMode" />
            <span>Tailwind</span>
          </div>
        </div>
      </div>

      <!-- Backend -->
      <div class="skill-category">
        <h3>{{ $t("skills.backend") }}</h3>
        <div class="skill-list">
          <div class="skill">
            <font-awesome-icon :icon="['fab', 'node-js']" class="skill-icon" />
            <span>Node.js</span>
          </div>
          <div class="skill">
            <NestJSIcon :isDarkMode="isDarkMode" />
            <span>NestJS</span>
          </div>
          <div class="skill">
            <font-awesome-icon :icon="['fab', 'php']" class="skill-icon" />
            <span>PHP</span>
          </div>
          <div class="skill">
            <font-awesome-icon :icon="['fab', 'laravel']" class="skill-icon" />
            <span>Laravel</span>
          </div>
          <div class="skill">
            <CSharpIcon :isDarkMode="isDarkMode" />
            <span>C#</span>
          </div>
          <div class="skill">
            <font-awesome-icon :icon="['fab', 'java']" class="skill-icon" />
            <span>Java</span>
          </div>
          <div class="skill">
            <KotlinIcon :isDarkMode="isDarkMode" />
            <span>Kotlin</span>
          </div>
        </div>
      </div>

      <!-- Bases de datos -->
      <div class="skill-category">
        <h3>{{ $t("skills.databases") }}</h3>
        <div class="skill-list">
          <div class="skill">
            <font-awesome-icon :icon="['fa', 'database']" class="skill-icon" />
            <span>SQL</span>
          </div>
          <div class="skill">
            <MySQLIcon :isDarkMode="isDarkMode" />
            <span>MySQL</span>
          </div>
          <div class="skill">
            <PrismaIcon :isDarkMode="isDarkMode" />
            <span>Prisma</span>
          </div>
        </div>
      </div>

      <!-- Herramientas -->
      <div class="skill-category">
        <h3>{{ $t("skills.tools") }}</h3>
        <div class="skill-list">
          <div class="skill">
            <font-awesome-icon :icon="['fab', 'git-alt']" class="skill-icon" />
            <span>Git</span>
          </div>
          <div class="skill">
            <font-awesome-icon :icon="['fab', 'github']" class="skill-icon" />
            <span>GitHub</span>
          </div>
          <div class="skill">
            <font-awesome-icon
              :icon="['fab', 'atlassian']"
              class="skill-icon"
            />
            <span>Jira</span>
          </div>
          <div class="skill">
            <font-awesome-icon :icon="['fab', 'docker']" class="skill-icon" />
            <span>Docker</span>
          </div>
          <div class="skill">
            <font-awesome-icon :icon="['fab', 'figma']" class="skill-icon" />
            <span>Figma</span>
          </div>
          <div class="skill">
            <JestIcon :isDarkMode="isDarkMode" />
            <span>Jest</span>
          </div>
          <div class="skill">
            <AzureIcon :isDarkMode="isDarkMode" />
            <span>Azure DevOps</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CSharpIcon from "@/components/icons/CSharpIcon.vue";
import TailwindIcon from "@/components/icons/TailwindIcon.vue";
import KotlinIcon from "@/components/icons/KotlinIcon.vue";
import MySQLIcon from "@/components/icons/MySQLIcon.vue";
import PrismaIcon from "@/components/icons/PrismaIcon.vue";
import NestJSIcon from "@/components/icons/NestJSIcon.vue";
import SassIcon from "@/components/icons/SassIcon.vue";
import AzureIcon from "@/components/icons/AzureIcon.vue";
import JestIcon from "@/components/icons/JestIcon.vue";

export default {
  name: "SkillsComponent",
  components: {
    JestIcon,
    AzureIcon,
    SassIcon,
    NestJSIcon,
    PrismaIcon,
    CSharpIcon,
    TailwindIcon,
    KotlinIcon,
    MySQLIcon,
  },
  computed: {
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    },
  },
};
</script>

<style scoped>
.skills {
  padding: 40px 20px;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}

h2 {
  margin-bottom: 40px;
  color: #333;
}

.skills-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.skill-category {
  background-color: #f9f9f9;
  border-radius: 10px;
  padding: 0px 20px 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  justify-content: space-between;
}

.skill-category:hover {
  transform: translateY(-10px);
}

h3 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #42b983;
}

.skill-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.skill {
  display: flex;
  align-items: center;
  gap: 10px;
}

.skill-icon {
  width: 24px;
  height: 24px;
}

.skill span {
  font-size: 1rem;
  color: #555;
}

@media (max-width: 768px) {
  .skills-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

/* Estilos para el modo oscuro */
.dark-mode .skills {
  color: #f0f0f0;
}

.dark-mode .skills h2 {
  color: #f0f0f0;
}

.dark-mode .skill-category {
  background-color: #3a3a50;
}

.dark-mode .skill-category:hover {
  transform: translateY(-10px);
}

.dark-mode .skill span {
  color: #d0d0d0;
}
</style>
